import { apis } from '@/config';
import { api } from '@/api/api';
import { mailUnfinishedMailTable } from './mail_action_store_model';
import { util } from '@/api/util';
class MailDraftApiImpl {
    constructor() {
        this.name = apis.mailDraftApiImpl;
        this.db = api.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    async getDraftMailCount() {
        const allDraftMail = await this.db.getByRangeCondition(Object.assign({}, mailUnfinishedMailTable));
        const cidSet = new Set();
        allDraftMail.forEach(item => {
            cidSet.add(item.cid);
        });
        return cidSet.size || 0;
    }
    async getAllDraftMail() {
        const allDraftMail = await this.db.getByRangeCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { start: 0, count: 500, desc: false }));
        const orderedAllDraftMail = util.setDataOrder({
            data: allDraftMail,
            orderBy: [['createTime', false]],
        });
        const cidMap = new Map();
        orderedAllDraftMail.forEach(item => {
            const { cid } = item;
            if (cidMap.has(cid)) {
                cidMap.set(cid, [...(cidMap.get(cid) || []), item]);
            }
            else {
                cidMap.set(cid, [item]);
            }
        });
        return cidMap || {};
    }
    async deleteDraftMailByCid(cid) {
        const cidArr = Array.isArray(cid) ? cid : [cid];
        try {
            const delNum = await this.db.deleteByByRangeCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { adCondition: {
                    field: 'cid',
                    type: 'anyOf',
                    args: cidArr,
                } }));
            return {
                success: true,
                data: delNum,
            };
        }
        catch (error) {
            console.log('删除草稿邮件失败', error);
            return {
                success: false,
                message: '删除草稿邮件失败',
            };
        }
    }
    async replaceDraftMailByCid(cid, replaceCid) {
        try {
            const resArr = await this.db.getByRangeCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { adCondition: {
                    field: 'cid',
                    type: 'anyOf',
                    args: [replaceCid],
                } }));
            await this.db.deleteByByRangeCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { adCondition: {
                    field: 'cid',
                    type: 'anyOf',
                    args: [replaceCid],
                } }));
            const replacedArr = resArr.map(item => (Object.assign(Object.assign({}, item), { cid })));
            await this.db.putAll(mailUnfinishedMailTable, replacedArr);
            return {
                success: true,
                data: replacedArr,
            };
        }
        catch (error) {
            console.log('替换草稿cid失败', error);
            return {
                success: false,
                message: '替换草稿cid失败',
            };
        }
    }
    async clearDraftMail() {
        try {
            const delNum = await this.db.deleteByByRangeCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { adCondition: {
                    field: 'cid',
                    type: 'above',
                    args: [0],
                } }));
            return {
                success: true,
                data: delNum,
            };
        }
        catch (error) {
            console.log('清空草稿邮件失败', error);
            return {
                success: false,
                message: '清空草稿邮件失败',
            };
        }
    }
    async getLatestedDraftByCid(cid) {
        try {
            const mainAccountEmail = this.systemApi.getMainAccount1().email;
            if (!mainAccountEmail) {
                return {
                    success: false,
                    message: '找不到主账号',
                };
            }
            const cidDrafts = await this.db.getByEqCondition(Object.assign(Object.assign({}, mailUnfinishedMailTable), { _dbAccount: mainAccountEmail, query: { cid } }));
            if (!cidDrafts.length) {
                return {
                    success: false,
                    message: `本地未存储${cid}的草稿`,
                };
            }
            const orderedCidDraftMail = util.setDataOrder({
                data: cidDrafts,
                orderBy: [['createTime', false]],
            });
            const latestedVersion = orderedCidDraftMail[0];
            const { draftId, draftVersionId } = latestedVersion;
            let createBySelf = false;
            if (draftId) {
                const draftParams = {
                    id: draftId,
                    mailType: 'draft',
                    writeType: 'editDraft',
                    withoutPlaceholder: true,
                    extraData: {
                        draftVersionId: draftVersionId || '',
                    },
                };
                try {
                    const res = await this.mailApi.initModel(draftParams);
                    createBySelf = false;
                    return {
                        success: true,
                        data: res,
                    };
                }
                catch (error) {
                    console.error('initModelByDraftError', error);
                    createBySelf = true;
                }
            }
            else {
                createBySelf = true;
            }
            if (!!createBySelf) {
                const initParams = {
                    writeType: 'common',
                    mailType: 'common',
                    result: Object.assign(Object.assign({}, latestedVersion), { recoverCid: latestedVersion.cid }),
                    withoutPlaceholder: true,
                };
                const res = await this.mailApi.initModel(initParams);
                return {
                    success: true,
                    data: res,
                };
            }
            throw new Error('获取失败');
        }
        catch (error) {
            console.log(`根据cid${cid}获取最近草稿失败`, error);
            return {
                success: false,
                message: `根据cid${cid}获取最近草稿失败`,
            };
        }
    }
    async recoverDraft(draft) {
        const { draftId, draftVersionId } = draft;
        if (draftId) {
            const draftParams = {
                id: draftId,
                mailType: 'draft',
                writeType: 'editDraft',
                withoutPlaceholder: true,
                extraData: {
                    draftVersionId: draftVersionId || '',
                },
            };
            this.mailApi.callWriteLetterFunc(draftParams);
        }
        else {
            const initParams = {
                writeType: 'common',
                mailType: 'common',
                result: Object.assign(Object.assign({}, draft), { recoverCid: draft.cid }),
                withoutPlaceholder: true,
            };
            this.mailApi.callWriteLetterFunc(initParams);
        }
    }
}
const mailDraftApiImpl = new MailDraftApiImpl();
api.registerLogicalApi(mailDraftApiImpl);
export default mailDraftApiImpl;
